import * as yup from "yup";

const yesterdayDate = new Date();
yesterdayDate.setDate(yesterdayDate.getDate() - 2);

export const newPatientSchema = yup
  .object()
  .shape({
    firstName: yup
      .string("Enter a valid first name")
      .required("First name is required"),
    lastName: yup
      .string("Enter a valid last name")
      .required("Last name is required"),
    contactNumber: yup
      .string("Enter a valid contact number")
      .matches(/^[0-9]*$/, "Contact number should only contain numbers")
      .min(11, "Contact number must have a length of 11 characters")
      .max(11, "Contact number must have a length of 11 characters")
      .required("Contact number is required"),
    email: yup
      .string()
      .email("Enter a valid email")
      .required("Email is required"),
    address: yup
      .string("Enter a valid address")
      .required("Address is required"),
    dateOfBirth: yup.date().typeError("Date of birth must be a valid date"),
    sex: yup.string().nullable(),
    termsOfPaymentId: yup.string(),
    appointmentSchedule: yup.date().when("type", {
      is: "Lead",
      then: yup.date().min(yesterdayDate, "Past dates are not allowed"),
      otherwise: yup
        .date()
        .min(yesterdayDate, "Past dates are not allowed")
        .required("Appointment schedule is required"),
    }),
    type: yup.string().required("Service is required"),
    sourceId: yup.string("Enter a valid source").required("Source is required"),
    alignerMaterialId: yup.string(),
  })
  .required();
